import { render, staticRenderFns } from "./UpdateProductModal.vue?vue&type=template&id=95dfa138&"
import script from "./UpdateProductModal.vue?vue&type=script&lang=js&"
export * from "./UpdateProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports